//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.1.0 (NJsonSchema v10.7.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class ClientV2 {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'https://staging.pulse.cloud/api/core';
  }

  /**
   * @return Success
   */
  moduleCache_DeleteDELETE(projectId: number, moduleName: string): Observable<DeleteProjectCacheForModuleResponse> {
    let url_ = this.baseUrl + '/v2/cache/projects/{projectId}/modules/{moduleName}';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (moduleName === undefined || moduleName === null) throw new Error("The parameter 'moduleName' must be defined.");
    url_ = url_.replace('{moduleName}', encodeURIComponent('' + moduleName));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processModuleCache_DeleteDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processModuleCache_DeleteDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<DeleteProjectCacheForModuleResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<DeleteProjectCacheForModuleResponse>;
        })
      );
  }

  protected processModuleCache_DeleteDELETE(
    response: HttpResponseBase
  ): Observable<DeleteProjectCacheForModuleResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as DeleteProjectCacheForModuleResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<DeleteProjectCacheForModuleResponse>(null as any);
  }

  /**
   * @return Success
   */
  projectCache_DeleteCacheForProjectDELETE(projectId: number): Observable<DeleteProjectCacheResponse> {
    let url_ = this.baseUrl + '/v2/cache/projects/{projectId}';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProjectCache_DeleteCacheForProjectDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProjectCache_DeleteCacheForProjectDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<DeleteProjectCacheResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<DeleteProjectCacheResponse>;
        })
      );
  }

  protected processProjectCache_DeleteCacheForProjectDELETE(
    response: HttpResponseBase
  ): Observable<DeleteProjectCacheResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as DeleteProjectCacheResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<DeleteProjectCacheResponse>(null as any);
  }

  /**
   * @return Success
   */
  projectCache_GetAllCacheKeysForProjectGET(projectId: number): Observable<GetAllProjectCacheKeysResponse> {
    let url_ = this.baseUrl + '/v2/cache/projects/{projectId}';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProjectCache_GetAllCacheKeysForProjectGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProjectCache_GetAllCacheKeysForProjectGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetAllProjectCacheKeysResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<GetAllProjectCacheKeysResponse>;
        })
      );
  }

  protected processProjectCache_GetAllCacheKeysForProjectGET(
    response: HttpResponseBase
  ): Observable<GetAllProjectCacheKeysResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetAllProjectCacheKeysResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<GetAllProjectCacheKeysResponse>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  resourceCache_AddDataIntoCachePOST(
    projectId: number,
    resourceId: number,
    key: string,
    body?: AddDataIntoCacheNew | undefined
  ): Observable<AddDataIntoCacheResponse> {
    let url_ = this.baseUrl + '/v2/cache/projects/{projectId}/resources/{resourceId}/keys/{key}';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (key === undefined || key === null) throw new Error("The parameter 'key' must be defined.");
    url_ = url_.replace('{key}', encodeURIComponent('' + key));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResourceCache_AddDataIntoCachePOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResourceCache_AddDataIntoCachePOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AddDataIntoCacheResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<AddDataIntoCacheResponse>;
        })
      );
  }

  protected processResourceCache_AddDataIntoCachePOST(
    response: HttpResponseBase
  ): Observable<AddDataIntoCacheResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as AddDataIntoCacheResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<AddDataIntoCacheResponse>(null as any);
  }

  /**
   * @return Success
   */
  resourceCache_GetDataFromCacheGET(
    projectId: number,
    resourceId: number,
    key: string
  ): Observable<GetDataFromCacheResponse> {
    let url_ = this.baseUrl + '/v2/cache/projects/{projectId}/resources/{resourceId}/keys/{key}';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (key === undefined || key === null) throw new Error("The parameter 'key' must be defined.");
    url_ = url_.replace('{key}', encodeURIComponent('' + key));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResourceCache_GetDataFromCacheGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResourceCache_GetDataFromCacheGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetDataFromCacheResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<GetDataFromCacheResponse>;
        })
      );
  }

  protected processResourceCache_GetDataFromCacheGET(response: HttpResponseBase): Observable<GetDataFromCacheResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetDataFromCacheResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result404: any = null;
          result404 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<GetDataFromCacheResponse>(null as any);
  }

  /**
   * @return Success
   */
  resourceCache_DeleteDELETE(
    projectId: number,
    resourceId: number,
    key: string
  ): Observable<DeleteDataFromCacheResponse> {
    let url_ = this.baseUrl + '/v2/cache/projects/{projectId}/resources/{resourceId}/keys/{key}';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (key === undefined || key === null) throw new Error("The parameter 'key' must be defined.");
    url_ = url_.replace('{key}', encodeURIComponent('' + key));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResourceCache_DeleteDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResourceCache_DeleteDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<DeleteDataFromCacheResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<DeleteDataFromCacheResponse>;
        })
      );
  }

  protected processResourceCache_DeleteDELETE(response: HttpResponseBase): Observable<DeleteDataFromCacheResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as DeleteDataFromCacheResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result404: any = null;
          result404 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<DeleteDataFromCacheResponse>(null as any);
  }

  /**
   * @return Success
   */
  resourceCache_DeleteAllDELETE(projectId: number, resourceId: number): Observable<DeleteAllCachesForResourceResponse> {
    let url_ = this.baseUrl + '/v2/cache/projects/{projectId}/resources/{resourceId}/keys';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResourceCache_DeleteAllDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResourceCache_DeleteAllDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<DeleteAllCachesForResourceResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<DeleteAllCachesForResourceResponse>;
        })
      );
  }

  protected processResourceCache_DeleteAllDELETE(
    response: HttpResponseBase
  ): Observable<DeleteAllCachesForResourceResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as DeleteAllCachesForResourceResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result404: any = null;
          result404 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<DeleteAllCachesForResourceResponse>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param withSqlAnalytics (optional)
   * @param parentId (optional)
   * @param body (optional)
   * @return Success
   */
  filter_CreateDefaultValuesPOST(
    projectId: number,
    resourceId: number,
    useCache?: boolean | undefined,
    withSqlAnalytics?: boolean | undefined,
    parentId?: number | undefined,
    body?: FilterDTO[] | undefined
  ): Observable<CreateFilterDefaultValues> {
    let url_ = this.baseUrl + '/v2/projects/{projectId}/resources/{resourceId}/filters/create-default-values?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (withSqlAnalytics === null) throw new Error("The parameter 'withSqlAnalytics' cannot be null.");
    else if (withSqlAnalytics !== undefined)
      url_ += 'withSqlAnalytics=' + encodeURIComponent('' + withSqlAnalytics) + '&';
    if (parentId === null) throw new Error("The parameter 'parentId' cannot be null.");
    else if (parentId !== undefined) url_ += 'parentId=' + encodeURIComponent('' + parentId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processFilter_CreateDefaultValuesPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processFilter_CreateDefaultValuesPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CreateFilterDefaultValues>;
            }
          } else return _observableThrow(response_) as any as Observable<CreateFilterDefaultValues>;
        })
      );
  }

  protected processFilter_CreateDefaultValuesPOST(response: HttpResponseBase): Observable<CreateFilterDefaultValues> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as CreateFilterDefaultValues);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<CreateFilterDefaultValues>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param withSqlAnalytics (optional)
   * @param parentId (optional)
   * @param excludedFilterGroupIds (optional)
   * @param body (optional)
   * @return Success
   */
  filter_CreateFilterPOST(
    projectId: number,
    resourceId: number,
    useCache?: boolean | undefined,
    withSqlAnalytics?: boolean | undefined,
    parentId?: number | undefined,
    excludedFilterGroupIds?: number[] | undefined,
    body?: FilterDTO[] | undefined
  ): Observable<CreateFilterResponse> {
    let url_ = this.baseUrl + '/v2/projects/{projectId}/resources/{resourceId}/filters/create-filter?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (withSqlAnalytics === null) throw new Error("The parameter 'withSqlAnalytics' cannot be null.");
    else if (withSqlAnalytics !== undefined)
      url_ += 'withSqlAnalytics=' + encodeURIComponent('' + withSqlAnalytics) + '&';
    if (parentId === null) throw new Error("The parameter 'parentId' cannot be null.");
    else if (parentId !== undefined) url_ += 'parentId=' + encodeURIComponent('' + parentId) + '&';
    if (excludedFilterGroupIds === null) throw new Error("The parameter 'excludedFilterGroupIds' cannot be null.");
    else if (excludedFilterGroupIds !== undefined)
      excludedFilterGroupIds &&
        excludedFilterGroupIds.forEach((item) => {
          url_ += 'excludedFilterGroupIds=' + encodeURIComponent('' + item) + '&';
        });
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processFilter_CreateFilterPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processFilter_CreateFilterPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CreateFilterResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<CreateFilterResponse>;
        })
      );
  }

  protected processFilter_CreateFilterPOST(response: HttpResponseBase): Observable<CreateFilterResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as CreateFilterResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<CreateFilterResponse>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param withSqlAnalytics (optional)
   * @param parentId (optional)
   * @param excludedFilterGroupIds (optional)
   * @param body (optional)
   * @return Success
   */
  filter_CreateFilterV2POST(
    projectId: number,
    resourceId: number,
    useCache?: boolean | undefined,
    withSqlAnalytics?: boolean | undefined,
    parentId?: number | undefined,
    excludedFilterGroupIds?: number[] | undefined,
    body?: FilterDTO[] | undefined
  ): Observable<CreateFilterResponse> {
    let url_ = this.baseUrl + '/v2/projects/{projectId}/resources/{resourceId}/filters/create?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (withSqlAnalytics === null) throw new Error("The parameter 'withSqlAnalytics' cannot be null.");
    else if (withSqlAnalytics !== undefined)
      url_ += 'withSqlAnalytics=' + encodeURIComponent('' + withSqlAnalytics) + '&';
    if (parentId === null) throw new Error("The parameter 'parentId' cannot be null.");
    else if (parentId !== undefined) url_ += 'parentId=' + encodeURIComponent('' + parentId) + '&';
    if (excludedFilterGroupIds === null) throw new Error("The parameter 'excludedFilterGroupIds' cannot be null.");
    else if (excludedFilterGroupIds !== undefined)
      excludedFilterGroupIds &&
        excludedFilterGroupIds.forEach((item) => {
          url_ += 'excludedFilterGroupIds=' + encodeURIComponent('' + item) + '&';
        });
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processFilter_CreateFilterV2POST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processFilter_CreateFilterV2POST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CreateFilterResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<CreateFilterResponse>;
        })
      );
  }

  protected processFilter_CreateFilterV2POST(response: HttpResponseBase): Observable<CreateFilterResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as CreateFilterResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<CreateFilterResponse>(null as any);
  }

  /**
   * @param useCache (optional)
   * @return Success
   */
  management_InitUsermanagementGET(projectId: number, useCache?: boolean | undefined): Observable<ManagementInitDTOV2> {
    let url_ = this.baseUrl + '/v2/project/{projectId}/management/init?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processManagement_InitUsermanagementGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processManagement_InitUsermanagementGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ManagementInitDTOV2>;
            }
          } else return _observableThrow(response_) as any as Observable<ManagementInitDTOV2>;
        })
      );
  }

  protected processManagement_InitUsermanagementGET(response: HttpResponseBase): Observable<ManagementInitDTOV2> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ManagementInitDTOV2);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ManagementInitDTOV2>(null as any);
  }

  /**
   * Get a paged result of Pulse.Common.Data.ResourceDTO.
   * @param projectId The id for the project.
   * @param resourceTypeId (optional) A set of resource type id's, which you want the Pulse.Common.Data.ResourceDTOfor.
   * @param useCache (optional) Get the data from a available cache with `true`, or fetch and renew the cache with `false`.
   * @param offset (optional) The offset means the start element for start fetching the Pulse.Common.Data.ResourceDTO
   * @param limit (optional) The page size for the expected page. Like 10,20 or 100.
   * @param search (optional) A search string for the name or the description of a Pulse.Common.Data.Resource
   * @return Success
   */
  resource_GetResourcesGET(
    projectId: number,
    resourceTypeId?: number[] | undefined,
    useCache?: boolean | undefined,
    offset?: number | undefined,
    limit?: number | undefined,
    search?: string | undefined
  ): Observable<Page_1OfResourceDTO> {
    let url_ = this.baseUrl + '/v2/project/{projectId}/resource?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceTypeId === null) throw new Error("The parameter 'resourceTypeId' cannot be null.");
    else if (resourceTypeId !== undefined)
      resourceTypeId &&
        resourceTypeId.forEach((item) => {
          url_ += 'resourceTypeId=' + encodeURIComponent('' + item) + '&';
        });
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (offset === null) throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined) url_ += 'offset=' + encodeURIComponent('' + offset) + '&';
    if (limit === null) throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined) url_ += 'limit=' + encodeURIComponent('' + limit) + '&';
    if (search === null) throw new Error("The parameter 'search' cannot be null.");
    else if (search !== undefined) url_ += 'search=' + encodeURIComponent('' + search) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResource_GetResourcesGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResource_GetResourcesGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Page_1OfResourceDTO>;
            }
          } else return _observableThrow(response_) as any as Observable<Page_1OfResourceDTO>;
        })
      );
  }

  protected processResource_GetResourcesGET(response: HttpResponseBase): Observable<Page_1OfResourceDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Page_1OfResourceDTO);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<Page_1OfResourceDTO>(null as any);
  }

  /**
   * Get a paged result of Pulse.Common.Data.ResourceFull from a given offset and the amount of data which are wanted.
   * @param projectId The id for the project.
   * @param resourceTypeId (optional) A set of resource type id's, which you want the Pulse.Common.Data.ResourceFullfor.
   * @param useCache (optional) Get the data from a available cache with `true`, or fetch and renew the cache with `false`.
   * @param offset (optional) The offset means the start element for start fetching a set of Pulse.Common.Data.ResourceDTO.Like 10,38, 100
   * @param limit (optional) The page size for the expected page. Like 10,20 or 100.
   * @param search (optional) A search string for the name or the description of a Pulse.Common.Data.Resource
   * @return Success
   */
  resource_GetResourcesFullGET(
    projectId: number,
    resourceTypeId?: number[] | undefined,
    useCache?: boolean | undefined,
    offset?: number | undefined,
    limit?: number | undefined,
    search?: string | undefined
  ): Observable<Page_1OfResourceFull> {
    let url_ = this.baseUrl + '/v2/project/{projectId}/resource/full?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceTypeId === null) throw new Error("The parameter 'resourceTypeId' cannot be null.");
    else if (resourceTypeId !== undefined)
      resourceTypeId &&
        resourceTypeId.forEach((item) => {
          url_ += 'resourceTypeId=' + encodeURIComponent('' + item) + '&';
        });
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (offset === null) throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined) url_ += 'offset=' + encodeURIComponent('' + offset) + '&';
    if (limit === null) throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined) url_ += 'limit=' + encodeURIComponent('' + limit) + '&';
    if (search === null) throw new Error("The parameter 'search' cannot be null.");
    else if (search !== undefined) url_ += 'search=' + encodeURIComponent('' + search) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResource_GetResourcesFullGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResource_GetResourcesFullGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Page_1OfResourceFull>;
            }
          } else return _observableThrow(response_) as any as Observable<Page_1OfResourceFull>;
        })
      );
  }

  protected processResource_GetResourcesFullGET(response: HttpResponseBase): Observable<Page_1OfResourceFull> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Page_1OfResourceFull);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<Page_1OfResourceFull>(null as any);
  }

  /**
   * Attach a resource to another resource. Add a child resource to a parent one.
   * @param resourceId The resource id for the child one.
   * @param resourceParentId The resource id which is the parent one.
   * @param projectId The id for the project.
   * @param useCache (optional) Get the data from a available cache with `true`, or fetch and renew the cache with `false`.
   * @param sortOrder (optional) The sort order for the child resource. Begins with 0..n
   * @param hasInheritReadPermission (optional) Defines if the attached resource can read by default when reading the parent or if dedicated permission is necessary
   * @return Success
   */
  resource_AttachResourceChildToResourceParentPOST(
    resourceId: number,
    resourceParentId: number,
    projectId: number,
    useCache?: boolean | undefined,
    sortOrder?: number | undefined,
    hasInheritReadPermission?: number | undefined
  ): Observable<ResourceFull> {
    let url_ = this.baseUrl + '/v2/project/{projectId}/resource/{resourceId}/parent/{resourceParentId}?';
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (resourceParentId === undefined || resourceParentId === null)
      throw new Error("The parameter 'resourceParentId' must be defined.");
    url_ = url_.replace('{resourceParentId}', encodeURIComponent('' + resourceParentId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (sortOrder === null) throw new Error("The parameter 'sortOrder' cannot be null.");
    else if (sortOrder !== undefined) url_ += 'sortOrder=' + encodeURIComponent('' + sortOrder) + '&';
    if (hasInheritReadPermission === null) throw new Error("The parameter 'hasInheritReadPermission' cannot be null.");
    else if (hasInheritReadPermission !== undefined)
      url_ += 'hasInheritReadPermission=' + encodeURIComponent('' + hasInheritReadPermission) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResource_AttachResourceChildToResourceParentPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResource_AttachResourceChildToResourceParentPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ResourceFull>;
            }
          } else return _observableThrow(response_) as any as Observable<ResourceFull>;
        })
      );
  }

  protected processResource_AttachResourceChildToResourceParentPOST(
    response: HttpResponseBase
  ): Observable<ResourceFull> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ResourceFull);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ResourceFull>(null as any);
  }

  /**
   * Detach a resource from another resource. Remove a child resource from a parent one.
   * @param resourceId The resource id for the child one.
   * @param resourceParentId The resource id which is the parent one.
   * @param projectId The id for the project.
   * @param useCache (optional) Get the data from a available cache with `true`, or fetch and renew the cache with `false`.
   * @return Success
   */
  resource_DetachResourceChildToResourceParentDELETE(
    resourceId: number,
    resourceParentId: number,
    projectId: number,
    useCache?: boolean | undefined
  ): Observable<ResourceFull> {
    let url_ = this.baseUrl + '/v2/project/{projectId}/resource/{resourceId}/parent/{resourceParentId}?';
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (resourceParentId === undefined || resourceParentId === null)
      throw new Error("The parameter 'resourceParentId' must be defined.");
    url_ = url_.replace('{resourceParentId}', encodeURIComponent('' + resourceParentId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResource_DetachResourceChildToResourceParentDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResource_DetachResourceChildToResourceParentDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ResourceFull>;
            }
          } else return _observableThrow(response_) as any as Observable<ResourceFull>;
        })
      );
  }

  protected processResource_DetachResourceChildToResourceParentDELETE(
    response: HttpResponseBase
  ): Observable<ResourceFull> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ResourceFull);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ResourceFull>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  roleGeneralAccess_SetGeneralAccessPOST(
    projectId: number,
    roleId: number,
    useCache?: boolean | undefined,
    body?: GeneralAccessFor | undefined
  ): Observable<UpdateRoleGeneralAccessResponse> {
    let url_ = this.baseUrl + '/v2/projects/{projectId}/roles/{roleId}/general-access?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRoleGeneralAccess_SetGeneralAccessPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRoleGeneralAccess_SetGeneralAccessPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UpdateRoleGeneralAccessResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<UpdateRoleGeneralAccessResponse>;
        })
      );
  }

  protected processRoleGeneralAccess_SetGeneralAccessPOST(
    response: HttpResponseBase
  ): Observable<UpdateRoleGeneralAccessResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as UpdateRoleGeneralAccessResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<UpdateRoleGeneralAccessResponse>(null as any);
  }

  /**
   * @param resourceTypeId (optional)
   * @param useCache (optional)
   * @return Success
   */
  roleGeneralAccess_DeleteGeneralAccessDELETE(
    projectId: number,
    roleId: number,
    resourceTypeId?: number | undefined,
    useCache?: boolean | undefined
  ): Observable<DeleteRoleGeneralAccessResponse> {
    let url_ = this.baseUrl + '/v2/projects/{projectId}/roles/{roleId}/general-access?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (resourceTypeId === null) throw new Error("The parameter 'resourceTypeId' cannot be null.");
    else if (resourceTypeId !== undefined) url_ += 'resourceTypeId=' + encodeURIComponent('' + resourceTypeId) + '&';
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRoleGeneralAccess_DeleteGeneralAccessDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRoleGeneralAccess_DeleteGeneralAccessDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<DeleteRoleGeneralAccessResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<DeleteRoleGeneralAccessResponse>;
        })
      );
  }

  protected processRoleGeneralAccess_DeleteGeneralAccessDELETE(
    response: HttpResponseBase
  ): Observable<DeleteRoleGeneralAccessResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as DeleteRoleGeneralAccessResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<DeleteRoleGeneralAccessResponse>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  roleResourceAccess_SetRoleResourceAccessPOST(
    projectId: number,
    roleId: number,
    useCache?: boolean | undefined,
    body?: ResourceAccessFor | undefined
  ): Observable<UpdateRoleResourceAccessResponse> {
    let url_ = this.baseUrl + '/v2/projects/{projectId}/roles/{roleId}/resource-access?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRoleResourceAccess_SetRoleResourceAccessPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRoleResourceAccess_SetRoleResourceAccessPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UpdateRoleResourceAccessResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<UpdateRoleResourceAccessResponse>;
        })
      );
  }

  protected processRoleResourceAccess_SetRoleResourceAccessPOST(
    response: HttpResponseBase
  ): Observable<UpdateRoleResourceAccessResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as UpdateRoleResourceAccessResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<UpdateRoleResourceAccessResponse>(null as any);
  }

  /**
   * @param resourceId (optional)
   * @param useCache (optional)
   * @return Success
   */
  roleResourceAccess_DeleteRoleResourceAccessDELETE(
    projectId: number,
    roleId: number,
    resourceId?: number | undefined,
    useCache?: boolean | undefined
  ): Observable<DeleteRoleResourceAccessResponse> {
    let url_ = this.baseUrl + '/v2/projects/{projectId}/roles/{roleId}/resource-access?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (resourceId === null) throw new Error("The parameter 'resourceId' cannot be null.");
    else if (resourceId !== undefined) url_ += 'resourceId=' + encodeURIComponent('' + resourceId) + '&';
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRoleResourceAccess_DeleteRoleResourceAccessDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRoleResourceAccess_DeleteRoleResourceAccessDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<DeleteRoleResourceAccessResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<DeleteRoleResourceAccessResponse>;
        })
      );
  }

  protected processRoleResourceAccess_DeleteRoleResourceAccessDELETE(
    response: HttpResponseBase
  ): Observable<DeleteRoleResourceAccessResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as DeleteRoleResourceAccessResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<DeleteRoleResourceAccessResponse>(null as any);
  }

  /**
   * Retrieves role full, Auth: AdminPrivilege : RoleAdmin, UserAdminLight
   * @param projectId Project ID
   * @param roleId Role ID
   * @param useCache (optional) >Whether to use caching
   * @return Success
   */
  roleFull_GetRoleFullGET(
    projectId: number,
    roleId: number,
    useCache?: boolean | undefined
  ): Observable<GetRoleFullResponse> {
    let url_ = this.baseUrl + '/v2/projects/{projectId}/roles/{roleId}/full?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRoleFull_GetRoleFullGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRoleFull_GetRoleFullGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetRoleFullResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<GetRoleFullResponse>;
        })
      );
  }

  protected processRoleFull_GetRoleFullGET(response: HttpResponseBase): Observable<GetRoleFullResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as GetRoleFullResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<GetRoleFullResponse>(null as any);
  }

  /**
   * Returns all roles for your project. You will get a paged result.
   * @param projectId The project id.
   * @param page (optional) The current page number. Like: 1,5 or 10.
   * @param pageSize (optional) The size of one page should be. Like: 10,20 or 50.
   * @param sortOrderColumn (optional)
   * @param sortOrderAscending (optional)
   * @param searchString (optional)
   * @param useCache (optional)
   * @return Success
   */
  role_GetRolesGET(
    projectId: number,
    page?: number | undefined,
    pageSize?: number | undefined,
    sortOrderColumn?: RoleColumnEnum | undefined,
    sortOrderAscending?: boolean | undefined,
    searchString?: string | undefined,
    useCache?: boolean | undefined
  ): Observable<GetAllRolesResponse> {
    let url_ = this.baseUrl + '/v2/projects/{projectId}/roles?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (page === null) throw new Error("The parameter 'page' cannot be null.");
    else if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&';
    if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&';
    if (sortOrderColumn === null) throw new Error("The parameter 'sortOrderColumn' cannot be null.");
    else if (sortOrderColumn !== undefined) url_ += 'sortOrderColumn=' + encodeURIComponent('' + sortOrderColumn) + '&';
    if (sortOrderAscending === null) throw new Error("The parameter 'sortOrderAscending' cannot be null.");
    else if (sortOrderAscending !== undefined)
      url_ += 'sortOrderAscending=' + encodeURIComponent('' + sortOrderAscending) + '&';
    if (searchString === null) throw new Error("The parameter 'searchString' cannot be null.");
    else if (searchString !== undefined) url_ += 'searchString=' + encodeURIComponent('' + searchString) + '&';
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRole_GetRolesGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRole_GetRolesGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetAllRolesResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<GetAllRolesResponse>;
        })
      );
  }

  protected processRole_GetRolesGET(response: HttpResponseBase): Observable<GetAllRolesResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as GetAllRolesResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<GetAllRolesResponse>(null as any);
  }

  /**
   * Add Role to Project, Auth: AdminPrivilege, RoleAdmin
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  role_AddRolePOST(
    projectId: number,
    useCache?: boolean | undefined,
    body?: RoleDTO | undefined
  ): Observable<AddRoleResponse> {
    let url_ = this.baseUrl + '/v2/projects/{projectId}/roles?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRole_AddRolePOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRole_AddRolePOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AddRoleResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<AddRoleResponse>;
        })
      );
  }

  protected processRole_AddRolePOST(response: HttpResponseBase): Observable<AddRoleResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as AddRoleResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<AddRoleResponse>(null as any);
  }

  /**
   * Get Role, Auth: AdminPrivilege, RoleAdmin, UserAdminLight
   * @param projectId Project ID
   * @param roleId Role ID
   * @param useCache (optional) >Whether to use caching
   * @return Success
   */
  role_GetRoleGET(projectId: number, roleId: number, useCache?: boolean | undefined): Observable<GetRoleResponse> {
    let url_ = this.baseUrl + '/v2/projects/{projectId}/roles/{roleId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRole_GetRoleGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRole_GetRoleGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetRoleResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<GetRoleResponse>;
        })
      );
  }

  protected processRole_GetRoleGET(response: HttpResponseBase): Observable<GetRoleResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as GetRoleResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<GetRoleResponse>(null as any);
  }

  /**
   * Update Role, Auth: AdminPrivilege, RoleAdmin
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  role_UpdateRolePUT(
    projectId: number,
    roleId: number,
    useCache?: boolean | undefined,
    body?: RoleDTO | undefined
  ): Observable<UpdateRoleResponse> {
    let url_ = this.baseUrl + '/v2/projects/{projectId}/roles/{roleId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRole_UpdateRolePUT(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRole_UpdateRolePUT(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UpdateRoleResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<UpdateRoleResponse>;
        })
      );
  }

  protected processRole_UpdateRolePUT(response: HttpResponseBase): Observable<UpdateRoleResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UpdateRoleResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetailsException);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<UpdateRoleResponse>(null as any);
  }

  /**
   * Delete Role from Project, Auth: AdminPrivilege, RoleAdmin
   * @param useCache (optional)
   * @return Success
   */
  role_DeleteRoleDELETE(
    projectId: number,
    roleId: number,
    useCache?: boolean | undefined
  ): Observable<DeleteRoleResponse> {
    let url_ = this.baseUrl + '/v2/projects/{projectId}/roles/{roleId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRole_DeleteRoleDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRole_DeleteRoleDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<DeleteRoleResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<DeleteRoleResponse>;
        })
      );
  }

  protected processRole_DeleteRoleDELETE(response: HttpResponseBase): Observable<DeleteRoleResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as DeleteRoleResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<DeleteRoleResponse>(null as any);
  }

  /**
   * Add Role to AccessPolicy, Auth: AdminPrivilege, RoleAdmin
   * @param useCache (optional)
   * @return Success
   */
  roleToAccessPolicy_AddRoleToAccessPolicyPOST(
    roleId: number,
    accessPolicyId: number,
    projectId: number,
    useCache?: boolean | undefined
  ): Observable<AddRoleToAccessPolicyResponse> {
    let url_ = this.baseUrl + '/v2/projects/{projectId}/roles/{roleId}/access-policies/{accessPolicyId}?';
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (accessPolicyId === undefined || accessPolicyId === null)
      throw new Error("The parameter 'accessPolicyId' must be defined.");
    url_ = url_.replace('{accessPolicyId}', encodeURIComponent('' + accessPolicyId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRoleToAccessPolicy_AddRoleToAccessPolicyPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRoleToAccessPolicy_AddRoleToAccessPolicyPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AddRoleToAccessPolicyResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<AddRoleToAccessPolicyResponse>;
        })
      );
  }

  protected processRoleToAccessPolicy_AddRoleToAccessPolicyPOST(
    response: HttpResponseBase
  ): Observable<AddRoleToAccessPolicyResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as AddRoleToAccessPolicyResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<AddRoleToAccessPolicyResponse>(null as any);
  }

  /**
   * Delete Role from AccessPolicy, Auth: AdminPrivilege, RoleAdmin
   * @param useCache (optional)
   * @return Success
   */
  roleToAccessPolicy_DeleteRoleToAccessPolicyDELETE(
    roleId: number,
    accessPolicyId: number,
    projectId: number,
    useCache?: boolean | undefined
  ): Observable<DeleteRoleFromAccessPolicyResponse> {
    let url_ = this.baseUrl + '/v2/projects/{projectId}/roles/{roleId}/access-policies/{accessPolicyId}?';
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (accessPolicyId === undefined || accessPolicyId === null)
      throw new Error("The parameter 'accessPolicyId' must be defined.");
    url_ = url_.replace('{accessPolicyId}', encodeURIComponent('' + accessPolicyId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRoleToAccessPolicy_DeleteRoleToAccessPolicyDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRoleToAccessPolicy_DeleteRoleToAccessPolicyDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<DeleteRoleFromAccessPolicyResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<DeleteRoleFromAccessPolicyResponse>;
        })
      );
  }

  protected processRoleToAccessPolicy_DeleteRoleToAccessPolicyDELETE(
    response: HttpResponseBase
  ): Observable<DeleteRoleFromAccessPolicyResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as DeleteRoleFromAccessPolicyResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<DeleteRoleFromAccessPolicyResponse>(null as any);
  }

  /**
   * Get all users for specified role, Auth: AdminPrivilege, UserAdmin, UserAdminLight
   * @param roleId Role ID
   * @param projectId Project ID
   * @param pageNumber (optional) Page number
   * @param pageSize (optional) Page size
   * @param sortOrderColumn (optional) Sort order column
   * @param sortOderAscending (optional) Sort order ascending
   * @param searchString (optional) Search string
   * @param useCache (optional) Whether to use caching
   * @return Success
   */
  roleToUser_GetUsersForRoleGET(
    roleId: number,
    projectId: number,
    pageNumber?: number | undefined,
    pageSize?: number | undefined,
    sortOrderColumn?: UserColumnEnum | undefined,
    sortOderAscending?: boolean | undefined,
    searchString?: string | undefined,
    useCache?: boolean | undefined
  ): Observable<GetUsersForRoleResponse> {
    let url_ = this.baseUrl + '/v2/projects/{projectId}/roles/{roleId}/users?';
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (pageNumber === null) throw new Error("The parameter 'pageNumber' cannot be null.");
    else if (pageNumber !== undefined) url_ += 'pageNumber=' + encodeURIComponent('' + pageNumber) + '&';
    if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&';
    if (sortOrderColumn === null) throw new Error("The parameter 'sortOrderColumn' cannot be null.");
    else if (sortOrderColumn !== undefined) url_ += 'sortOrderColumn=' + encodeURIComponent('' + sortOrderColumn) + '&';
    if (sortOderAscending === null) throw new Error("The parameter 'sortOderAscending' cannot be null.");
    else if (sortOderAscending !== undefined)
      url_ += 'sortOderAscending=' + encodeURIComponent('' + sortOderAscending) + '&';
    if (searchString === null) throw new Error("The parameter 'searchString' cannot be null.");
    else if (searchString !== undefined) url_ += 'searchString=' + encodeURIComponent('' + searchString) + '&';
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRoleToUser_GetUsersForRoleGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRoleToUser_GetUsersForRoleGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetUsersForRoleResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<GetUsersForRoleResponse>;
        })
      );
  }

  protected processRoleToUser_GetUsersForRoleGET(response: HttpResponseBase): Observable<GetUsersForRoleResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as GetUsersForRoleResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<GetUsersForRoleResponse>(null as any);
  }

  /**
   * Retrieves user full, Auth: AdminPrivilege : UserAdmin, UserAdminLight
   * @param useCache (optional)
   * @return Success
   */
  userFull_GetUserFullGET(
    userId: number,
    projectId: number,
    useCache?: boolean | undefined
  ): Observable<GetUserFullResponse> {
    let url_ = this.baseUrl + '/v2/projects/{projectId}/users/{userId}/full?';
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUserFull_GetUserFullGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUserFull_GetUserFullGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetUserFullResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<GetUserFullResponse>;
        })
      );
  }

  protected processUserFull_GetUserFullGET(response: HttpResponseBase): Observable<GetUserFullResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as GetUserFullResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<GetUserFullResponse>(null as any);
  }

  /**
   * Retrieves user profile, Auth: Project
   * @param useCache (optional)
   * @return Success
   */
  userProfile_GetUserProfileGET(
    userId: number,
    projectId: number,
    useCache?: boolean | undefined
  ): Observable<GetUserProfileResponse> {
    let url_ = this.baseUrl + '/v2/projects/{projectId}/users/{userId}/profile?';
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUserProfile_GetUserProfileGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUserProfile_GetUserProfileGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetUserProfileResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<GetUserProfileResponse>;
        })
      );
  }

  protected processUserProfile_GetUserProfileGET(response: HttpResponseBase): Observable<GetUserProfileResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as GetUserProfileResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<GetUserProfileResponse>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  userSearch_SearchUsersByIdsPOST(
    projectId: number,
    useCache?: boolean | undefined,
    body?: number[] | undefined
  ): Observable<SearchUsersResponse> {
    let url_ = this.baseUrl + '/v2/projects/{projectId}/users/search-by-ids?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUserSearch_SearchUsersByIdsPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUserSearch_SearchUsersByIdsPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SearchUsersResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<SearchUsersResponse>;
        })
      );
  }

  protected processUserSearch_SearchUsersByIdsPOST(response: HttpResponseBase): Observable<SearchUsersResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as SearchUsersResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetailsException);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<SearchUsersResponse>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  userSearch_SearchUsersByExternalIdsPOST(
    projectId: number,
    useCache?: boolean | undefined,
    body?: string[] | undefined
  ): Observable<SearchUsersResponse> {
    let url_ = this.baseUrl + '/v2/projects/{projectId}/users/search-by-external-ids?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUserSearch_SearchUsersByExternalIdsPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUserSearch_SearchUsersByExternalIdsPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SearchUsersResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<SearchUsersResponse>;
        })
      );
  }

  protected processUserSearch_SearchUsersByExternalIdsPOST(
    response: HttpResponseBase
  ): Observable<SearchUsersResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as SearchUsersResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetailsException);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<SearchUsersResponse>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  userSearch_SearchUsersByEmailsPOST(
    projectId: number,
    useCache?: boolean | undefined,
    body?: string[] | undefined
  ): Observable<SearchUsersByEmailsResponse> {
    let url_ = this.baseUrl + '/v2/projects/{projectId}/users/search-by-emails?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUserSearch_SearchUsersByEmailsPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUserSearch_SearchUsersByEmailsPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SearchUsersByEmailsResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<SearchUsersByEmailsResponse>;
        })
      );
  }

  protected processUserSearch_SearchUsersByEmailsPOST(
    response: HttpResponseBase
  ): Observable<SearchUsersByEmailsResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SearchUsersByEmailsResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetailsException);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<SearchUsersByEmailsResponse>(null as any);
  }

  /**
   * Returns all users for your project. You will get a paged result.
   * @param projectId The project id.
   * @param page (optional) The current page number. Like: 1,5 or 10.
   * @param pageSize (optional) The size of one page should be. Like: 10,20 or 50.
   * @param sortOrderColumn (optional)
   * @param sortOrderAscending (optional)
   * @param searchString (optional)
   * @param useCache (optional)
   * @return Success
   */
  userToProject_GetUsersFromProjectGET(
    projectId: number,
    page?: number | undefined,
    pageSize?: number | undefined,
    sortOrderColumn?: UserColumnEnum | undefined,
    sortOrderAscending?: boolean | undefined,
    searchString?: string | undefined,
    useCache?: boolean | undefined
  ): Observable<GetUsersResponse> {
    let url_ = this.baseUrl + '/v2/projects/{projectId}/users?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (page === null) throw new Error("The parameter 'page' cannot be null.");
    else if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&';
    if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&';
    if (sortOrderColumn === null) throw new Error("The parameter 'sortOrderColumn' cannot be null.");
    else if (sortOrderColumn !== undefined) url_ += 'sortOrderColumn=' + encodeURIComponent('' + sortOrderColumn) + '&';
    if (sortOrderAscending === null) throw new Error("The parameter 'sortOrderAscending' cannot be null.");
    else if (sortOrderAscending !== undefined)
      url_ += 'sortOrderAscending=' + encodeURIComponent('' + sortOrderAscending) + '&';
    if (searchString === null) throw new Error("The parameter 'searchString' cannot be null.");
    else if (searchString !== undefined) url_ += 'searchString=' + encodeURIComponent('' + searchString) + '&';
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUserToProject_GetUsersFromProjectGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUserToProject_GetUsersFromProjectGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetUsersResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<GetUsersResponse>;
        })
      );
  }

  protected processUserToProject_GetUsersFromProjectGET(response: HttpResponseBase): Observable<GetUsersResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as GetUsersResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<GetUsersResponse>(null as any);
  }

  /**
   * Add User to Project,  Auth: AdminPrivilege, UserAdmin, UserAdminLight
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  userToProject_AddUserToProjectPOST(
    projectId: number,
    useCache?: boolean | undefined,
    body?: number | undefined
  ): Observable<AddUserToProjectResponse> {
    let url_ = this.baseUrl + '/v2/projects/{projectId}/users?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUserToProject_AddUserToProjectPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUserToProject_AddUserToProjectPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AddUserToProjectResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<AddUserToProjectResponse>;
        })
      );
  }

  protected processUserToProject_AddUserToProjectPOST(
    response: HttpResponseBase
  ): Observable<AddUserToProjectResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as AddUserToProjectResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<AddUserToProjectResponse>(null as any);
  }

  /**
   * Returns a specific user with the given user id.
   * @param projectId The project id.
   * @param userId The id for the user you requested.
   * @param useCache (optional)
   * @return Success
   */
  userToProject_GetUserFromGET(
    projectId: number,
    userId: number,
    useCache?: boolean | undefined
  ): Observable<GetUserFromProjectResponse> {
    let url_ = this.baseUrl + '/v2/projects/{projectId}/users/{userId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUserToProject_GetUserFromGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUserToProject_GetUserFromGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetUserFromProjectResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<GetUserFromProjectResponse>;
        })
      );
  }

  protected processUserToProject_GetUserFromGET(response: HttpResponseBase): Observable<GetUserFromProjectResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetUserFromProjectResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<GetUserFromProjectResponse>(null as any);
  }

  /**
   * Remove user from Project, Auth: AdminPrivilege, UserAdmin
   * @param useCache (optional)
   * @return Success
   */
  userToProject_DeleteUserFromProjectDELETE(
    userId: number,
    projectId: number,
    useCache?: boolean | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/v2/projects/{projectId}/users/{userId}?';
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUserToProject_DeleteUserFromProjectDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUserToProject_DeleteUserFromProjectDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processUserToProject_DeleteUserFromProjectDELETE(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Add Users to Project,  Auth: AdminPrivilege, UserAdmin
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  userToProject_AddUserToProjectBulkPOST(
    projectId: number,
    useCache?: boolean | undefined,
    body?: string[] | undefined
  ): Observable<AddUserToProjectBulkResponse> {
    let url_ = this.baseUrl + '/v2/projects/{projectId}/users/bulk?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUserToProject_AddUserToProjectBulkPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUserToProject_AddUserToProjectBulkPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AddUserToProjectBulkResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<AddUserToProjectBulkResponse>;
        })
      );
  }

  protected processUserToProject_AddUserToProjectBulkPOST(
    response: HttpResponseBase
  ): Observable<AddUserToProjectBulkResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as AddUserToProjectBulkResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<AddUserToProjectBulkResponse>(null as any);
  }

  /**
   * Returns all users available on the pulse platform. You will get a paged result, Auth: AdminPrivilege, UserAdmin, UserAdminLight
   * @param projectId The project id.
   * @param page (optional) The current page number. Like: 1,5 or 10.
   * @param pageSize (optional) The size of one page should be. Like: 10,20 or 50.
   * @param sortOrderColumn (optional)
   * @param sortOrderAscending (optional)
   * @param searchString (optional)
   * @param useCache (optional)
   * @return Success
   */
  user_GetUsersGlobalGET(
    projectId: number,
    page?: number | undefined,
    pageSize?: number | undefined,
    sortOrderColumn?: UserColumnEnum | undefined,
    sortOrderAscending?: boolean | undefined,
    searchString?: string | undefined,
    useCache?: boolean | undefined
  ): Observable<GetUsersResponse> {
    let url_ = this.baseUrl + '/v2/projects/{projectId}/users/global?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (page === null) throw new Error("The parameter 'page' cannot be null.");
    else if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&';
    if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&';
    if (sortOrderColumn === null) throw new Error("The parameter 'sortOrderColumn' cannot be null.");
    else if (sortOrderColumn !== undefined) url_ += 'sortOrderColumn=' + encodeURIComponent('' + sortOrderColumn) + '&';
    if (sortOrderAscending === null) throw new Error("The parameter 'sortOrderAscending' cannot be null.");
    else if (sortOrderAscending !== undefined)
      url_ += 'sortOrderAscending=' + encodeURIComponent('' + sortOrderAscending) + '&';
    if (searchString === null) throw new Error("The parameter 'searchString' cannot be null.");
    else if (searchString !== undefined) url_ += 'searchString=' + encodeURIComponent('' + searchString) + '&';
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_GetUsersGlobalGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_GetUsersGlobalGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetUsersResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<GetUsersResponse>;
        })
      );
  }

  protected processUser_GetUsersGlobalGET(response: HttpResponseBase): Observable<GetUsersResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as GetUsersResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<GetUsersResponse>(null as any);
  }

  /**
   * Add a new user globally to Pulse, Auth: AdminPrivilege, UserAdmin
   * @param projectId The project id.
   * @param body (optional) The user which has to be added.
   * @return Success
   */
  user_AddUserPOST(projectId: number, body?: UserBase | undefined): Observable<AddUserResponse> {
    let url_ = this.baseUrl + '/v2/projects/{projectId}/users/global';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_AddUserPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_AddUserPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AddUserResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<AddUserResponse>;
        })
      );
  }

  protected processUser_AddUserPOST(response: HttpResponseBase): Observable<AddUserResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as AddUserResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<AddUserResponse>(null as any);
  }

  /**
   * Remove/De-Activate user from pulse, Auth: AdminPrivilege, UserAdmin
   * @return Success
   */
  user_DeleteUserDELETE(userId: number): Observable<DeleteUserResponse> {
    let url_ = this.baseUrl + '/v2/global/users/{userId}';
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_DeleteUserDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_DeleteUserDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<DeleteUserResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<DeleteUserResponse>;
        })
      );
  }

  protected processUser_DeleteUserDELETE(response: HttpResponseBase): Observable<DeleteUserResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as DeleteUserResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<DeleteUserResponse>(null as any);
  }

  /**
   * Returns all users available on the pulse platform independent on project id. You will get a paged result, Auth: ProjectCreator
   * @param page (optional) The current page number. Like: 1,5 or 10.
   * @param pageSize (optional) The size of one page should be. Like: 10,20 or 50.
   * @param sortOrderColumn (optional)
   * @param sortOderAscending (optional)
   * @param searchString (optional)
   * @param useCache (optional)
   * @return Success
   */
  user_GetUserListGET(
    page?: number | undefined,
    pageSize?: number | undefined,
    sortOrderColumn?: UserColumnEnum | undefined,
    sortOderAscending?: boolean | undefined,
    searchString?: string | undefined,
    useCache?: boolean | undefined
  ): Observable<GetUsersResponse> {
    let url_ = this.baseUrl + '/v2/global/users?';
    if (page === null) throw new Error("The parameter 'page' cannot be null.");
    else if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&';
    if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&';
    if (sortOrderColumn === null) throw new Error("The parameter 'sortOrderColumn' cannot be null.");
    else if (sortOrderColumn !== undefined) url_ += 'sortOrderColumn=' + encodeURIComponent('' + sortOrderColumn) + '&';
    if (sortOderAscending === null) throw new Error("The parameter 'sortOderAscending' cannot be null.");
    else if (sortOderAscending !== undefined)
      url_ += 'sortOderAscending=' + encodeURIComponent('' + sortOderAscending) + '&';
    if (searchString === null) throw new Error("The parameter 'searchString' cannot be null.");
    else if (searchString !== undefined) url_ += 'searchString=' + encodeURIComponent('' + searchString) + '&';
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_GetUserListGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_GetUserListGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetUsersResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<GetUsersResponse>;
        })
      );
  }

  protected processUser_GetUserListGET(response: HttpResponseBase): Observable<GetUsersResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as GetUsersResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          result500 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PulseProblemDetails);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<GetUsersResponse>(null as any);
  }
}

export interface ProblemDetails {
  type: string | undefined;
  title: string | undefined;
  status: number | undefined;
  detail: string | undefined;
  instance: string | undefined;
}

export interface ProblemDetailsException {
  targetSite: MethodBase;
  readonly message: string;
  readonly data: { [key: string]: any };
  innerException: Exception;
  helpLink: string | undefined;
  source: string | undefined;
  hResult: number;
  readonly stackTrace: string | undefined;
  problemDetails: PulseProblemDetails;
}

export interface PulseProblemDetails {
  responseType: string | undefined;
  title: string | undefined;
  details: string | undefined;
  statusCode: number;
  errorDetails: { [key: string]: any } | undefined;
}

export interface UserErrorResponse {
  responseType: string | undefined;
  statusCode: number;
  title: string | undefined;
  details: string | undefined;
  errors: string[] | undefined;
}

export interface CacheInfo {
  objectFromCache: boolean;
  cacheKey: string | undefined;
}

export interface AccessPolicyItem {
  accessPolicyId: number;
  resourceFlagProjectPage: boolean | undefined;
  projectId: number;
  projectName: string | undefined;
  projectShortName: string | undefined;
  actionId: number;
  actionName: string | undefined;
  resourceId: number;
  resourceName: string | undefined;
  resourceDescription: string | undefined;
  resourceTypeId: number;
  resourceTypeName: string | undefined;
  resourceImageLink: string | undefined;
  resourceSortOrder: number | undefined;
  roleId: number;
  roleIsInternal: boolean | undefined;
}

export interface ActionDTO {
  id: number;
  name: string | undefined;
  resourceTypeId: number;
}

export interface AddUserToProjectResponse {
  success: boolean;
}

export interface AdminPrivilege {
  id: number;
  name: string | undefined;
  description: string | undefined;
  lastUpdatedByUserId: number;
}

export interface Category {
  id: number;
  parentId: number;
  projectId: number;
  name: string | undefined;
  descriptionShort: string | undefined;
  descriptionLong: string | undefined;
  imageLink: string | undefined;
  sortOrder: number;
}

export interface PageInfo_1OfRoleDTO {
  currentPage: number;
  pageSize: number;
  items: RoleDTO[] | undefined;
  totalItems: number;
}

export interface PageInfo_1OfUserBase {
  currentPage: number;
  pageSize: number;
  items: UserBase[] | undefined;
  totalItems: number;
}

export interface FilterCategoryDTO {
  id: number;
  label: string | undefined;
  icon: string | undefined;
  order: number;
}

export interface FilterDTO {
  id: number;
  label: string | undefined;
  icon: string | undefined;
  filterType: string | undefined;
  filterCategoryId: number;
  filterGroupId: number;
  providerConnectionId: number;
  tablename: string | undefined;
  columns: Resource[] | undefined;
  order: number;
  hasAll: boolean | undefined;
  token: FilterTokenDTO[] | undefined;
  values: FilterValueDTO[] | undefined;
  valueRange: FilterValueRangeDTO;
  toolTip: string | undefined;
}

export interface FilterGroupDTO {
  id: number;
  name: string | undefined;
  sortOrder: number;
  showOnHeader: boolean;
  visibility: string | undefined;
  icon: string | undefined;
  toolTip: string | undefined;
  interdependentFilterGroups: number[] | undefined;
  filters: FilterDTO[] | undefined;
  categories: FilterCategoryDTO[] | undefined;
}

export interface FilterTokenDTO {
  label: string | undefined;
  selection: FilterValueDTO[] | undefined;
}

export interface FilterValueDTO {
  value: string | undefined;
  label: string | undefined;
  column: string | undefined;
  isSelected: boolean;
  isDisabled: boolean;
  children: FilterValueDTO[] | undefined;
}

export interface FilterValueRangeDTO {
  min: string | undefined;
  max: string | undefined;
  column: string | undefined;
}

export interface GetAllRolesResponse {
  cacheInfo: CacheInfo;
  roles: PageInfo_1OfRoleDTO;
}

export interface GetIsGlobalAdminResponse {
  cacheInfo: CacheInfo;
  isGlobalAdmin: boolean;
}

export interface GetRoleResponse {
  cacheInfo: CacheInfo;
  roleDto: RoleDTO;
}

export interface GetUserFromProjectResponse {
  cacheInfo: CacheInfo;
  user: UserBase;
}

export interface GetUserFullResponse {
  cacheInfo: CacheInfo;
  userFull: UserFull;
}

export interface GetUsersResponse {
  cacheInfo: CacheInfo;
  users: PageInfo_1OfUserBase;
}

export interface EMailAddress {
  mail: string | undefined;
  displayName: string | undefined;
}

export interface MailConfiguration {
  subject: string | undefined;
  body: string | undefined;
  isEncrypted: boolean;
  isSigned: boolean;
  isBodyHtml: boolean;
  attachments: string | undefined;
  displayName: string | undefined;
  replyTo: string | undefined;
}

export interface MailList {
  recipients: EMailAddress[] | undefined;
  copyReciepients: EMailAddress[] | undefined;
  blindCopyRecipients: EMailAddress[] | undefined;
  tag: string | undefined;
  customId: string | undefined;
  customIdType: string | undefined;
}

export interface MailSendRequest {
  projectId: number;
  mailConfiguration: MailConfiguration;
  mailList: MailList[] | undefined;
  contactData: any[] | undefined;
}

export interface MailSendResponse {
  success: boolean;
}

export interface ManagementInitDTO {
  users: UserBase[] | undefined;
  adminPrivileges: AdminPrivilege[] | undefined;
  resources: ResourceDTO[] | undefined;
  roles: RoleDTO[] | undefined;
  resourceTypes: ResourceTypeAccess[] | undefined;
}

export interface PermissionValueDTO {
  permissionSet: string | undefined;
  databaseColumn: string | undefined;
  databaseValue: string | undefined;
  rowLevelSecurityId: number;
  columnGroupId: number;
  columnDefinitionId: number;
}

export interface Project {
  id: number;
  name: string | undefined;
  description: string | undefined;
  shortName: string | undefined;
  isPublic: boolean;
  createdOn: Date;
  createdByUserId: number;
  properties: { [key: string]: string } | undefined;
}

export interface ProjectBase {
  id: number;
  name: string | undefined;
  description: string | undefined;
  shortName: string | undefined;
  isPublic: boolean;
  createdOn: Date;
  createdByUserId: number;
}

export interface ProjectDetail {
  projectId: number;
  projectName: string | undefined;
  projectShortName: string | undefined;
  properties: { [key: string]: string } | undefined;
}

export interface ProjectInitDTO {
  user: User;
  adminPrivilege: number[] | undefined;
  resources: ResourceDTO[] | undefined;
  resourceTypes: ResourceTypeAction[] | undefined;
  categories: Category[] | undefined;
  project: Project;
  tenantSettings: TenantSetting[] | undefined;
  isGlobalAdmin: boolean;
}

export interface ProjectPropertyDTO {
  id: number;
  projectId: number;
  name: string | undefined;
  value: string | undefined;
}

export interface ProviderConnection {
  id: number;
  providerType: string | undefined;
  sqlType: string | undefined;
  name: string | undefined;
  databaseName: string | undefined;
  server: string | undefined;
  proxy: string | undefined;
  awsSecret: string | undefined;
}

export interface ProviderConnectionDTO {
  id: number;
  name: string | undefined;
  resourceTypeId: number;
}

export interface Resource {
  id: number;
  name: string | undefined;
  description: string | undefined;
  imageLink: string | undefined;
  category: string | undefined;
  categoryId: number | undefined;
  subCategory: string | undefined;
  subCategoryId: number | undefined;
  resourceTypeId: number;
  flagProjectPage: boolean;
  projectId: number;
  sortOrder: number;
  createdOn: Date | undefined;
  createdByUserId: number;
  createdByUser: string | undefined;
  lastUpdatedOn: Date | undefined;
  lastUpdatedByUserId: number;
  lastUpdatedByUser: string | undefined;
  properties: { [key: string]: string } | undefined;
  fromCache: boolean;
}

export interface ResourceAccess {
  resourceId: number;
  actions: number[] | undefined;
  roleId: number;
  roleName: string | undefined;
  isInternal: boolean;
  isGeneralAccess: boolean;
}

export interface ResourceAccessRequest {
  resourceId: number;
  actions: number[] | undefined;
}

export interface ResourceBase {
  id: number;
  name: string | undefined;
  description: string | undefined;
  imageLink: string | undefined;
  category: string | undefined;
  categoryId: number | undefined;
  subCategory: string | undefined;
  subCategoryId: number | undefined;
  resourceTypeId: number;
  flagProjectPage: boolean;
  projectId: number;
  sortOrder: number;
  createdOn: Date | undefined;
  createdByUserId: number;
  createdByUser: string | undefined;
  lastUpdatedOn: Date | undefined;
  lastUpdatedByUserId: number;
  lastUpdatedByUser: string | undefined;
}

export interface ResourceDTO {
  id: number;
  name: string | undefined;
  description: string | undefined;
  imageLink: string | undefined;
  category: string | undefined;
  categoryId: number | undefined;
  subCategory: string | undefined;
  subCategoryId: number | undefined;
  resourceTypeId: number;
  flagProjectPage: boolean;
  projectId: number;
  sortOrder: number;
  createdOn: Date | undefined;
  createdByUserId: number;
  createdByUser: string | undefined;
  lastUpdatedOn: Date | undefined;
  lastUpdatedByUserId: number;
  lastUpdatedByUser: string | undefined;
  properties: { [key: string]: string } | undefined;
  fromCache: boolean;
  actions: string[] | undefined;
  childResourceIds: number[] | undefined;
  parentResourceIds: number[] | undefined;
}

export interface ResourceFull {
  id: number;
  name: string | undefined;
  description: string | undefined;
  imageLink: string | undefined;
  category: string | undefined;
  categoryId: number | undefined;
  subCategory: string | undefined;
  subCategoryId: number | undefined;
  resourceTypeId: number;
  flagProjectPage: boolean;
  projectId: number;
  sortOrder: number;
  createdOn: Date | undefined;
  createdByUserId: number;
  createdByUser: string | undefined;
  lastUpdatedOn: Date | undefined;
  lastUpdatedByUserId: number;
  lastUpdatedByUser: string | undefined;
  properties: { [key: string]: string } | undefined;
  fromCache: boolean;
  actions: string[] | undefined;
  childResourceIds: number[] | undefined;
  parentResourceIds: number[] | undefined;
  resourceToResourceProperties: { [key: string]: string } | undefined;
  childResources: ResourceFull[] | undefined;
}

export interface ResourceType {
  id: number;
  name: string | undefined;
  isInternal: boolean;
  isTopLevelResource: boolean;
}

export interface ResourceTypeAccess {
  id: number;
  name: string | undefined;
  isInternal: boolean;
  isTopLevelResource: boolean;
  actions: ActionDTO[] | undefined;
}

export interface ResourceTypeAccessGeneral {
  resourceTypeId: number;
  roleId: number;
  roleName: string | undefined;
  actions: number[] | undefined;
  categories: number[] | undefined;
}

export interface ResourceTypeAction {
  id: number;
  name: string | undefined;
  isInternal: boolean;
  isTopLevelResource: boolean;
  actions: string[] | undefined;
  categoryIds: number[] | undefined;
}

export interface ResourceTypeDefinition {
  id: number;
  resourceTypeId: number;
  propertyName: string | undefined;
  propertyTranslationKey: string | undefined;
  propertyType: string | undefined;
  defaultValue: string | undefined;
  valueList: string | undefined;
  visualizationType: string | undefined;
  relationalPropertyResourceTypeId: number;
  isMandatory: boolean;
  isSubResourceEagerlyLoaded: boolean;
  sortOrder: number;
}

export interface RoleAccess {
  roleId: number;
  resourceAccess: ResourceAccess[] | undefined;
}

export enum RoleColumnEnum {
  Id = 'Id',
  Name = 'Name',
  Description = 'Description',
}

export interface RoleDTO {
  id: number;
  name: string | undefined;
  description: string | undefined;
  projectId: number;
  isInternal: boolean | undefined;
}

export interface RoleFull {
  roleInfo: RoleDTO;
  resourceTypeAccess: ResourceTypeAccessGeneral[] | undefined;
  resourceAccess: ResourceAccess[] | undefined;
  userAttachedToThisRole: number[] | undefined;
}

export interface SearchUsersResponse {
  users: UserBase[] | undefined;
}

export interface Measure {
  value: number;
  unit: string | undefined;
}

export interface SqlAnalyticResult {
  class: string | undefined;
  method: string | undefined;
  sqlExecutionTime: Measure;
  sql: string | undefined;
  info: string | undefined;
}

export interface SqlAnalyticResults {
  totalMeasure: Measure;
  results: SqlAnalyticResult[] | undefined;
}

export interface TenantSetting {
  setting: string | undefined;
  value: string | undefined;
}

export interface User {
  id: number;
  externalId: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  email: string | undefined;
  orgCode: string | undefined;
  isActive: boolean | undefined;
  isApiUser: boolean | undefined;
  properties: { [key: string]: string } | undefined;
}

export interface UserBase {
  id: number;
  externalId: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  email: string | undefined;
  orgCode: string | undefined;
  isActive: boolean | undefined;
  isApiUser: boolean | undefined;
}

export interface UserFull {
  userBase: UserBase;
  adminPrivilege: number[] | undefined;
  resourceAccess: ResourceAccess[] | undefined;
  roleAccess: RoleAccess[] | undefined;
  properties: { [key: string]: string } | undefined;
  resourceTypeAccess: ResourceTypeAccessGeneral[] | undefined;
}

export interface UserProfile {
  userBase: UserBase;
  accessPolicy: AccessPolicyItem[] | undefined;
  adminPrivilege: number[] | undefined;
  resourceType: ResourceType[] | undefined;
  userProperties: { [key: string]: string } | undefined;
  projectProperties: { [key: string]: string } | undefined;
  fromCache: boolean;
}

export interface UserProjectAccess {
  id: number;
  externalId: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  email: string | undefined;
  orgCode: string | undefined;
  isActive: boolean | undefined;
  isApiUser: boolean | undefined;
  projectAccess: ProjectDetail[] | undefined;
  fromCache: boolean;
  isGlobalAdmin: boolean;
}

export interface CreateFilterDefaultValues {
  cacheInfo: CacheInfo;
  sqlAnalyticResults: SqlAnalyticResults;
  defaultFilter: FilterGroupDTO[] | undefined;
}

export interface CreateFilterResponse {
  cacheInfo: CacheInfo;
  sqlAnalyticResults: SqlAnalyticResults;
  defaultFilter: FilterGroupDTOLight[] | undefined;
}

export interface FilterDTOLight {
  id: number;
  label: string | undefined;
  icon: string | undefined;
  filterGroupId: number;
  order: number;
  token: FilterTokenDTO[] | undefined;
  toolTip: string | undefined;
  values: FilterValueDTO[] | undefined;
  valueRange: FilterValueRangeDTO;
  filterType: string | undefined;
}

export interface FilterGroupDTOLight {
  id: number;
  name: string | undefined;
  sortOrder: number;
  showOnHeader: boolean;
  visibility: string | undefined;
  icon: string | undefined;
  toolTip: string | undefined;
  interdependentFilterGroups: number[] | undefined;
  filters: FilterDTOLight[] | undefined;
  categories: FilterCategoryDTO[] | undefined;
}

export interface AddDataIntoCacheNew {
  content: string | undefined;
  cacheTime: string | undefined;
}

export interface AddDataIntoCacheResponse {}

export interface DeleteAllCachesForResourceResponse {
  amountOfRemovedKeys: number;
}

export interface DeleteDataFromCacheResponse {}

export interface DeleteProjectCacheForModuleResponse {
  amountOfRemovedKeys: number;
}

export interface DeleteProjectCacheResponse {
  amountOfRemovedKeys: number;
}

export interface GetAllProjectCacheKeysResponse {
  cacheKeys: string[] | undefined;
}

export interface GetDataFromCacheResponse {
  value: string | undefined;
}

export interface ManagementInitDTOV2 {
  adminPrivileges: AdminPrivilege[] | undefined;
  resources: ResourceDTO[] | undefined;
  resourceTypes: ResourceTypeAccess[] | undefined;
}

export interface DeleteRoleGeneralAccessResponse {
  deletedAccessPolicies: number[] | undefined;
}

export interface DeleteRoleResourceAccessResponse {
  deletedAccessPolicies: number[] | undefined;
}

export interface UpdateRoleGeneralAccessResponse {
  deletedAccessPoliciesToRoleIds: number[] | undefined;
  deletedAccessPolicies: number[] | undefined;
  insertedAccessPolicyIds: number[] | undefined;
  insertedAccessPoliciesToRoleIds: number[] | undefined;
}

export interface UpdateRoleResourceAccessResponse {
  deletedAccessPoliciesToRoleIds: number[] | undefined;
  deletedAccessPolicies: number[] | undefined;
  insertedAccessPolicyIds: number[] | undefined;
  insertedAccessPoliciesToRoleIds: number[] | undefined;
}

export interface UpdateRoleResponse {
  roleDto: RoleDTO;
}

export interface SearchUsersByEmailsResponse {
  usersByEmails: { [key: string]: UserBase } | undefined;
}

export interface SetupProjectRequest {
  surveySettings: SurveySettings;
}

export interface SetupProjectResponse {}

export interface SurveySettings {
  surveyType: SurveyType;
  landingPageUrl: string | undefined;
  themeId: number;
  contactEmail: string | undefined;
  pagePersistancy: number;
}

export enum SurveyType {
  OpenAccess = 'OpenAccess',
  AnonymousEmployee = 'AnonymousEmployee',
  InvitationOnly = 'InvitationOnly',
}

export interface PageDefinition {
  search: string | undefined;
  pageSize: number;
  page: number;
}

export interface Page_1OfResourceDTO {
  count: number;
  items: ResourceDTO[] | undefined;
  definition: PageDefinition;
}

export interface Page_1OfResourceFull {
  count: number;
  items: ResourceFull[] | undefined;
  definition: PageDefinition;
}

export interface DeleteGeneralAccessResponse {
  deletedAccessPolicies: number[] | undefined;
}

export interface GeneralAccessFor {
  actionIds: number[] | undefined;
  categoryIds: number[] | undefined;
}

export interface UpdateGeneralAccessResponse {
  deletedAccessPoliciesToRoleIds: number[] | undefined;
  deletedAccessPolicies: number[] | undefined;
  insertedAccessPolicyIds: number[] | undefined;
  insertedAccessPoliciesToRoleIds: number[] | undefined;
}

export interface ResourceAccessFor {
  actionIds: number[] | undefined;
  resourceId: number;
}

export interface AddRoleResponse {
  roleDto: RoleDTO;
}

export interface AddRoleToAccessPolicyResponse {
  isSuccess: boolean;
}

export interface DeleteRoleFromAccessPolicyResponse {
  isSuccess: boolean;
}

export interface DeleteRoleResponse {
  isSuccess: boolean;
}

export interface GetRoleFullResponse {
  cacheInfo: CacheInfo;
  roleFull: RoleFull;
}

export interface GetUsersForRoleResponse {
  cacheInfo: CacheInfo;
  roleUsers: PageInfo_1OfUserBase;
}

export interface AddProjectLanguageRequest {
  language: string | undefined;
  sortOrder: number;
}

export interface AddProjectLanguageResponse {
  cacheInfo: CacheInfo;
}

export interface DeleteProjectLanguageResponse {
  cacheInfo: CacheInfo;
  deletedLanguages: string | undefined;
}

export interface GetAllProjectLanguageResponse {
  cacheInfo: CacheInfo;
  languages: ProjectLanguage[] | undefined;
}

export interface ProjectLanguage {
  id: number;
  language: string | undefined;
  isS3Deployed: number;
  sortOrder: number;
  lastUpdatedByUserId: number;
}

export interface UpdateProjectLanguageRequest {
  language: string | undefined;
  sortOrder: number;
}

export interface UpdateProjectLanguageResponse {}

export interface AddOrUpdateProjectTranslationRequest {
  translations: ProjectTranslation[] | undefined;
}

export interface AddOrUpdateProjectTranslationResponse {
  success: boolean;
}

export interface GetAllProjectTranslationResponse {
  cacheInfo: CacheInfo;
  translations: { [key: string]: string } | undefined;
}

export interface ProjectTranslation {
  key: string | undefined;
  value: string | undefined;
  area: string | undefined;
}

export interface AddOrUpdateResourceTranslationByKeyRequest {
  key: string | undefined;
  translations: ResourceTranslation[] | undefined;
}

export interface AddOrUpdateResourceTranslationRequest {
  key: string | undefined;
  translations: ResourceTranslation[] | undefined;
}

export interface AddOrUpdateResourceTranslationResponse {
  itemsAffected: number;
}

export interface GetAllResourceTranslationResponse {
  cacheInfo: CacheInfo;
  translations: ResourceTranslation[] | undefined;
}

export interface ResourceTranslation {
  value: string | undefined;
  area: string | undefined;
  language: string | undefined;
}

export interface AddOrUpdateTranslationItem {
  resourceId: number;
  area: string | undefined;
  translationKey: string | undefined;
  translation: string | undefined;
  language: string | undefined;
}

export interface AddOrUpdateTranslationResponse {
  itemsAffected: number;
}

export interface AddOrUpdateTranslationsRequest {
  translations: AddOrUpdateTranslationItem[] | undefined;
}

export interface DeleteAllLanguagesTranslationItem {
  area: string | undefined;
  translationKey: string | undefined;
  resourceId: number;
}

export interface DeleteAllLanguagesTranslationsRequest {
  translations: DeleteAllLanguagesTranslationItem[] | undefined;
}

export interface DeleteTranslationsResponse {
  affectedItems: number;
}

export interface ExportTranslationsRequest {
  sourceLanguage: string | undefined;
  targetLanguage: string | undefined;
  fileType: string | undefined;
}

export interface GetJoinedTranslationsResponse {
  joinedTranslations: JoinedTranslation[] | undefined;
}

export interface ImportTranslationsResponse {
  affectedLanguages: string[] | undefined;
}

export interface JoinedTranslation {
  sourceLanguage: string | undefined;
  targetLanguage: string | undefined;
  resourceId: number;
  area: string | undefined;
  translationKey: string | undefined;
  sourceTranslation: string | undefined;
  targetTranslation: string | undefined;
}

export interface AddUserResponse {
  user: UserBase;
}

export interface AddUserToProjectBulkResponse {
  success: boolean;
}

export interface DeleteUserResponse {
  success: boolean;
}

export enum UserColumnEnum {
  Id = 'Id',
  ExternalId = 'ExternalId',
  FirstName = 'FirstName',
  LastName = 'LastName',
  Email = 'Email',
}

export interface GetUserProfileResponse {
  cacheInfo: CacheInfo;
  userProfile: UserProfile;
}

export interface Exception {
  targetSite: MethodBase;
  readonly message: string;
  readonly data: { [key: string]: any };
  innerException: Exception;
  helpLink: string | undefined;
  source: string | undefined;
  hResult: number;
  readonly stackTrace: string | undefined;
}

export interface IntPtr {}

export interface ModuleHandle {
  readonly mdStreamVersion: number;
}

export interface Assembly {
  readonly definedTypes: TypeInfo[];
  readonly exportedTypes: Type[];
  readonly codeBase: string | undefined;
  entryPoint: MethodInfo;
  readonly fullName: string | undefined;
  readonly imageRuntimeVersion: string;
  readonly isDynamic: boolean;
  readonly location: string;
  readonly reflectionOnly: boolean;
  readonly isCollectible: boolean;
  readonly isFullyTrusted: boolean;
  readonly customAttributes: CustomAttributeData[];
  readonly escapedCodeBase: string;
  manifestModule: Module;
  readonly modules: Module[];
  readonly globalAssemblyCache: boolean;
  readonly hostContext: number;
  securityRuleSet: SecurityRuleSet;
}

export enum CallingConventions {
  Standard = 'Standard',
  VarArgs = 'VarArgs',
  Any = 'Any',
  HasThis = 'HasThis',
  ExplicitThis = 'ExplicitThis',
}

export interface ConstructorInfo {
  readonly name: string;
  declaringType: Type;
  reflectedType: Type;
  module: Module;
  readonly customAttributes: CustomAttributeData[];
  readonly isCollectible: boolean;
  readonly metadataToken: number;
  attributes: MethodAttributes;
  methodImplementationFlags: MethodImplAttributes;
  callingConvention: CallingConventions;
  readonly isAbstract: boolean;
  readonly isConstructor: boolean;
  readonly isFinal: boolean;
  readonly isHideBySig: boolean;
  readonly isSpecialName: boolean;
  readonly isStatic: boolean;
  readonly isVirtual: boolean;
  readonly isAssembly: boolean;
  readonly isFamily: boolean;
  readonly isFamilyAndAssembly: boolean;
  readonly isFamilyOrAssembly: boolean;
  readonly isPrivate: boolean;
  readonly isPublic: boolean;
  readonly isConstructedGenericMethod: boolean;
  readonly isGenericMethod: boolean;
  readonly isGenericMethodDefinition: boolean;
  readonly containsGenericParameters: boolean;
  methodHandle: RuntimeMethodHandle;
  readonly isSecurityCritical: boolean;
  readonly isSecuritySafeCritical: boolean;
  readonly isSecurityTransparent: boolean;
  memberType: MemberTypes;
}

export interface CustomAttributeData {
  attributeType: Type;
  constructor: ConstructorInfo;
  readonly constructorArguments: CustomAttributeTypedArgument[];
  readonly namedArguments: CustomAttributeNamedArgument[];
}

export interface CustomAttributeNamedArgument {
  memberInfo: MemberInfo;
  typedValue: CustomAttributeTypedArgument;
  readonly memberName: string;
  readonly isField: boolean;
}

export interface CustomAttributeTypedArgument {
  argumentType: Type;
  value: any | undefined;
}

export enum EventAttributes {
  None = 'None',
  SpecialName = 'SpecialName',
  RTSpecialName = 'RTSpecialName',
}

export interface EventInfo {
  readonly name: string;
  declaringType: Type;
  reflectedType: Type;
  module: Module;
  readonly customAttributes: CustomAttributeData[];
  readonly isCollectible: boolean;
  readonly metadataToken: number;
  memberType: MemberTypes;
  attributes: EventAttributes;
  readonly isSpecialName: boolean;
  addMethod: MethodInfo;
  removeMethod: MethodInfo;
  raiseMethod: MethodInfo;
  readonly isMulticast: boolean;
  eventHandlerType: Type;
}

export enum FieldAttributes {
  PrivateScope = 'PrivateScope',
  Private = 'Private',
  FamANDAssem = 'FamANDAssem',
  Assembly = 'Assembly',
  Family = 'Family',
  FamORAssem = 'FamORAssem',
  Public = 'Public',
  FieldAccessMask = 'FieldAccessMask',
  Static = 'Static',
  InitOnly = 'InitOnly',
  Literal = 'Literal',
  NotSerialized = 'NotSerialized',
  HasFieldRVA = 'HasFieldRVA',
  SpecialName = 'SpecialName',
  RTSpecialName = 'RTSpecialName',
  HasFieldMarshal = 'HasFieldMarshal',
  PinvokeImpl = 'PinvokeImpl',
  HasDefault = 'HasDefault',
  ReservedMask = 'ReservedMask',
}

export interface FieldInfo {
  readonly name: string;
  declaringType: Type;
  reflectedType: Type;
  module: Module;
  readonly customAttributes: CustomAttributeData[];
  readonly isCollectible: boolean;
  readonly metadataToken: number;
  memberType: MemberTypes;
  attributes: FieldAttributes;
  fieldType: Type;
  readonly isInitOnly: boolean;
  readonly isLiteral: boolean;
  readonly isNotSerialized: boolean;
  readonly isPinvokeImpl: boolean;
  readonly isSpecialName: boolean;
  readonly isStatic: boolean;
  readonly isAssembly: boolean;
  readonly isFamily: boolean;
  readonly isFamilyAndAssembly: boolean;
  readonly isFamilyOrAssembly: boolean;
  readonly isPrivate: boolean;
  readonly isPublic: boolean;
  readonly isSecurityCritical: boolean;
  readonly isSecuritySafeCritical: boolean;
  readonly isSecurityTransparent: boolean;
  fieldHandle: RuntimeFieldHandle;
}

export enum GenericParameterAttributes {
  None = 'None',
  Covariant = 'Covariant',
  Contravariant = 'Contravariant',
  VarianceMask = 'VarianceMask',
  ReferenceTypeConstraint = 'ReferenceTypeConstraint',
  NotNullableValueTypeConstraint = 'NotNullableValueTypeConstraint',
  DefaultConstructorConstraint = 'DefaultConstructorConstraint',
  SpecialConstraintMask = 'SpecialConstraintMask',
}

export interface ICustomAttributeProvider {}

export interface MemberInfo {
  memberType: MemberTypes;
  declaringType: Type;
  reflectedType: Type;
  readonly name: string;
  module: Module;
  readonly customAttributes: CustomAttributeData[];
  readonly isCollectible: boolean;
  readonly metadataToken: number;
}

export enum MemberTypes {
  Constructor = 'Constructor',
  Event = 'Event',
  Field = 'Field',
  Method = 'Method',
  Property = 'Property',
  TypeInfo = 'TypeInfo',
  Custom = 'Custom',
  NestedType = 'NestedType',
  All = 'All',
}

export enum MethodAttributes {
  ReuseSlot = 'ReuseSlot',
  Private = 'Private',
  FamANDAssem = 'FamANDAssem',
  Assembly = 'Assembly',
  Family = 'Family',
  FamORAssem = 'FamORAssem',
  Public = 'Public',
  MemberAccessMask = 'MemberAccessMask',
  UnmanagedExport = 'UnmanagedExport',
  Static = 'Static',
  Final = 'Final',
  Virtual = 'Virtual',
  HideBySig = 'HideBySig',
  NewSlot = 'NewSlot',
  CheckAccessOnOverride = 'CheckAccessOnOverride',
  Abstract = 'Abstract',
  SpecialName = 'SpecialName',
  RTSpecialName = 'RTSpecialName',
  PinvokeImpl = 'PinvokeImpl',
  HasSecurity = 'HasSecurity',
  RequireSecObject = 'RequireSecObject',
  ReservedMask = 'ReservedMask',
}

export interface MethodBase {
  memberType: MemberTypes;
  readonly name: string;
  declaringType: Type;
  reflectedType: Type;
  module: Module;
  readonly customAttributes: CustomAttributeData[];
  readonly isCollectible: boolean;
  readonly metadataToken: number;
  attributes: MethodAttributes;
  methodImplementationFlags: MethodImplAttributes;
  callingConvention: CallingConventions;
  readonly isAbstract: boolean;
  readonly isConstructor: boolean;
  readonly isFinal: boolean;
  readonly isHideBySig: boolean;
  readonly isSpecialName: boolean;
  readonly isStatic: boolean;
  readonly isVirtual: boolean;
  readonly isAssembly: boolean;
  readonly isFamily: boolean;
  readonly isFamilyAndAssembly: boolean;
  readonly isFamilyOrAssembly: boolean;
  readonly isPrivate: boolean;
  readonly isPublic: boolean;
  readonly isConstructedGenericMethod: boolean;
  readonly isGenericMethod: boolean;
  readonly isGenericMethodDefinition: boolean;
  readonly containsGenericParameters: boolean;
  methodHandle: RuntimeMethodHandle;
  readonly isSecurityCritical: boolean;
  readonly isSecuritySafeCritical: boolean;
  readonly isSecurityTransparent: boolean;
}

export enum MethodImplAttributes {
  IL = 'IL',
  Native = 'Native',
  OPTIL = 'OPTIL',
  Runtime = 'Runtime',
  Unmanaged = 'Unmanaged',
  NoInlining = 'NoInlining',
  ForwardRef = 'ForwardRef',
  Synchronized = 'Synchronized',
  NoOptimization = 'NoOptimization',
  PreserveSig = 'PreserveSig',
  AggressiveInlining = 'AggressiveInlining',
  AggressiveOptimization = 'AggressiveOptimization',
  InternalCall = 'InternalCall',
  MaxMethodImplVal = 'MaxMethodImplVal',
}

export interface MethodInfo {
  readonly name: string;
  declaringType: Type;
  reflectedType: Type;
  module: Module;
  readonly customAttributes: CustomAttributeData[];
  readonly isCollectible: boolean;
  readonly metadataToken: number;
  attributes: MethodAttributes;
  methodImplementationFlags: MethodImplAttributes;
  callingConvention: CallingConventions;
  readonly isAbstract: boolean;
  readonly isConstructor: boolean;
  readonly isFinal: boolean;
  readonly isHideBySig: boolean;
  readonly isSpecialName: boolean;
  readonly isStatic: boolean;
  readonly isVirtual: boolean;
  readonly isAssembly: boolean;
  readonly isFamily: boolean;
  readonly isFamilyAndAssembly: boolean;
  readonly isFamilyOrAssembly: boolean;
  readonly isPrivate: boolean;
  readonly isPublic: boolean;
  readonly isConstructedGenericMethod: boolean;
  readonly isGenericMethod: boolean;
  readonly isGenericMethodDefinition: boolean;
  readonly containsGenericParameters: boolean;
  methodHandle: RuntimeMethodHandle;
  readonly isSecurityCritical: boolean;
  readonly isSecuritySafeCritical: boolean;
  readonly isSecurityTransparent: boolean;
  memberType: MemberTypes;
  returnParameter: ParameterInfo;
  returnType: Type;
  returnTypeCustomAttributes: ICustomAttributeProvider;
}

export interface Module {
  assembly: Assembly;
  readonly fullyQualifiedName: string;
  readonly name: string;
  readonly mdStreamVersion: number;
  readonly moduleVersionId: string;
  readonly scopeName: string;
  moduleHandle: ModuleHandle;
  readonly customAttributes: CustomAttributeData[];
  readonly metadataToken: number;
}

export enum ParameterAttributes {
  None = 'None',
  In = 'In',
  Out = 'Out',
  Lcid = 'Lcid',
  Retval = 'Retval',
  Optional = 'Optional',
  HasDefault = 'HasDefault',
  HasFieldMarshal = 'HasFieldMarshal',
  Reserved3 = 'Reserved3',
  Reserved4 = 'Reserved4',
  ReservedMask = 'ReservedMask',
}

export interface ParameterInfo {
  attributes: ParameterAttributes;
  member: MemberInfo;
  readonly name: string | undefined;
  parameterType: Type;
  readonly position: number;
  readonly isIn: boolean;
  readonly isLcid: boolean;
  readonly isOptional: boolean;
  readonly isOut: boolean;
  readonly isRetval: boolean;
  readonly defaultValue: any | undefined;
  readonly rawDefaultValue: any | undefined;
  readonly hasDefaultValue: boolean;
  readonly customAttributes: CustomAttributeData[];
  readonly metadataToken: number;
}

export enum PropertyAttributes {
  None = 'None',
  SpecialName = 'SpecialName',
  RTSpecialName = 'RTSpecialName',
  HasDefault = 'HasDefault',
  Reserved2 = 'Reserved2',
  Reserved3 = 'Reserved3',
  Reserved4 = 'Reserved4',
  ReservedMask = 'ReservedMask',
}

export interface PropertyInfo {
  readonly name: string;
  declaringType: Type;
  reflectedType: Type;
  module: Module;
  readonly customAttributes: CustomAttributeData[];
  readonly isCollectible: boolean;
  readonly metadataToken: number;
  memberType: MemberTypes;
  propertyType: Type;
  attributes: PropertyAttributes;
  readonly isSpecialName: boolean;
  readonly canRead: boolean;
  readonly canWrite: boolean;
  getMethod: MethodInfo;
  setMethod: MethodInfo;
}

export enum TypeAttributes {
  NotPublic = 'NotPublic',
  Public = 'Public',
  NestedPublic = 'NestedPublic',
  NestedPrivate = 'NestedPrivate',
  NestedFamily = 'NestedFamily',
  NestedAssembly = 'NestedAssembly',
  NestedFamANDAssem = 'NestedFamANDAssem',
  NestedFamORAssem = 'NestedFamORAssem',
  SequentialLayout = 'SequentialLayout',
  ExplicitLayout = 'ExplicitLayout',
  LayoutMask = 'LayoutMask',
  Interface = 'Interface',
  Abstract = 'Abstract',
  Sealed = 'Sealed',
  SpecialName = 'SpecialName',
  RTSpecialName = 'RTSpecialName',
  Import = 'Import',
  Serializable = 'Serializable',
  WindowsRuntime = 'WindowsRuntime',
  UnicodeClass = 'UnicodeClass',
  AutoClass = 'AutoClass',
  CustomFormatClass = 'CustomFormatClass',
  HasSecurity = 'HasSecurity',
  ReservedMask = 'ReservedMask',
  BeforeFieldInit = 'BeforeFieldInit',
  CustomFormatMask = 'CustomFormatMask',
}

export interface TypeInfo {
  readonly name: string;
  readonly customAttributes: CustomAttributeData[];
  readonly isCollectible: boolean;
  readonly metadataToken: number;
  readonly isInterface: boolean;
  memberType: MemberTypes;
  readonly namespace: string | undefined;
  readonly assemblyQualifiedName: string | undefined;
  readonly fullName: string | undefined;
  assembly: Assembly;
  module: Module;
  readonly isNested: boolean;
  declaringType: Type;
  declaringMethod: MethodBase;
  reflectedType: Type;
  underlyingSystemType: Type;
  readonly isTypeDefinition: boolean;
  readonly isArray: boolean;
  readonly isByRef: boolean;
  readonly isPointer: boolean;
  readonly isConstructedGenericType: boolean;
  readonly isGenericParameter: boolean;
  readonly isGenericTypeParameter: boolean;
  readonly isGenericMethodParameter: boolean;
  readonly isGenericType: boolean;
  readonly isGenericTypeDefinition: boolean;
  readonly isSZArray: boolean;
  readonly isVariableBoundArray: boolean;
  readonly isByRefLike: boolean;
  readonly hasElementType: boolean;
  readonly genericTypeArguments: Type[];
  readonly genericParameterPosition: number;
  genericParameterAttributes: GenericParameterAttributes;
  attributes: TypeAttributes;
  readonly isAbstract: boolean;
  readonly isImport: boolean;
  readonly isSealed: boolean;
  readonly isSpecialName: boolean;
  readonly isClass: boolean;
  readonly isNestedAssembly: boolean;
  readonly isNestedFamANDAssem: boolean;
  readonly isNestedFamily: boolean;
  readonly isNestedFamORAssem: boolean;
  readonly isNestedPrivate: boolean;
  readonly isNestedPublic: boolean;
  readonly isNotPublic: boolean;
  readonly isPublic: boolean;
  readonly isAutoLayout: boolean;
  readonly isExplicitLayout: boolean;
  readonly isLayoutSequential: boolean;
  readonly isAnsiClass: boolean;
  readonly isAutoClass: boolean;
  readonly isUnicodeClass: boolean;
  readonly isCOMObject: boolean;
  readonly isContextful: boolean;
  readonly isEnum: boolean;
  readonly isMarshalByRef: boolean;
  readonly isPrimitive: boolean;
  readonly isValueType: boolean;
  readonly isSignatureType: boolean;
  readonly isSecurityCritical: boolean;
  readonly isSecuritySafeCritical: boolean;
  readonly isSecurityTransparent: boolean;
  structLayoutAttribute: StructLayoutAttribute;
  typeInitializer: ConstructorInfo;
  typeHandle: RuntimeTypeHandle;
  readonly guid: string;
  baseType: Type;
  readonly isSerializable: boolean;
  readonly containsGenericParameters: boolean;
  readonly isVisible: boolean;
  readonly genericTypeParameters: Type[];
  readonly declaredConstructors: ConstructorInfo[];
  readonly declaredEvents: EventInfo[];
  readonly declaredFields: FieldInfo[];
  readonly declaredMembers: MemberInfo[];
  readonly declaredMethods: MethodInfo[];
  readonly declaredNestedTypes: TypeInfo[];
  readonly declaredProperties: PropertyInfo[];
  readonly implementedInterfaces: Type[];
}

export enum LayoutKind {
  Sequential = 'Sequential',
  Explicit = 'Explicit',
  Auto = 'Auto',
}

export interface StructLayoutAttribute {
  readonly typeId: any;
  value: LayoutKind;
}

export interface RuntimeFieldHandle {
  value: IntPtr;
}

export interface RuntimeMethodHandle {
  value: IntPtr;
}

export interface RuntimeTypeHandle {
  value: IntPtr;
}

export enum SecurityRuleSet {
  None = 'None',
  Level1 = 'Level1',
  Level2 = 'Level2',
}

export interface Type {
  readonly name: string;
  readonly customAttributes: CustomAttributeData[];
  readonly isCollectible: boolean;
  readonly metadataToken: number;
  readonly isInterface: boolean;
  memberType: MemberTypes;
  readonly namespace: string | undefined;
  readonly assemblyQualifiedName: string | undefined;
  readonly fullName: string | undefined;
  assembly: Assembly;
  module: Module;
  readonly isNested: boolean;
  declaringType: Type;
  declaringMethod: MethodBase;
  reflectedType: Type;
  underlyingSystemType: Type;
  readonly isTypeDefinition: boolean;
  readonly isArray: boolean;
  readonly isByRef: boolean;
  readonly isPointer: boolean;
  readonly isConstructedGenericType: boolean;
  readonly isGenericParameter: boolean;
  readonly isGenericTypeParameter: boolean;
  readonly isGenericMethodParameter: boolean;
  readonly isGenericType: boolean;
  readonly isGenericTypeDefinition: boolean;
  readonly isSZArray: boolean;
  readonly isVariableBoundArray: boolean;
  readonly isByRefLike: boolean;
  readonly hasElementType: boolean;
  readonly genericTypeArguments: Type[];
  readonly genericParameterPosition: number;
  genericParameterAttributes: GenericParameterAttributes;
  attributes: TypeAttributes;
  readonly isAbstract: boolean;
  readonly isImport: boolean;
  readonly isSealed: boolean;
  readonly isSpecialName: boolean;
  readonly isClass: boolean;
  readonly isNestedAssembly: boolean;
  readonly isNestedFamANDAssem: boolean;
  readonly isNestedFamily: boolean;
  readonly isNestedFamORAssem: boolean;
  readonly isNestedPrivate: boolean;
  readonly isNestedPublic: boolean;
  readonly isNotPublic: boolean;
  readonly isPublic: boolean;
  readonly isAutoLayout: boolean;
  readonly isExplicitLayout: boolean;
  readonly isLayoutSequential: boolean;
  readonly isAnsiClass: boolean;
  readonly isAutoClass: boolean;
  readonly isUnicodeClass: boolean;
  readonly isCOMObject: boolean;
  readonly isContextful: boolean;
  readonly isEnum: boolean;
  readonly isMarshalByRef: boolean;
  readonly isPrimitive: boolean;
  readonly isValueType: boolean;
  readonly isSignatureType: boolean;
  readonly isSecurityCritical: boolean;
  readonly isSecuritySafeCritical: boolean;
  readonly isSecurityTransparent: boolean;
  structLayoutAttribute: StructLayoutAttribute;
  typeInitializer: ConstructorInfo;
  typeHandle: RuntimeTypeHandle;
  readonly guid: string;
  baseType: Type;
  readonly isSerializable: boolean;
  readonly containsGenericParameters: boolean;
  readonly isVisible: boolean;
}

export class SwaggerException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isSwaggerException = true;

  static isSwaggerException(obj: any): obj is SwaggerException {
    return obj.isSwaggerException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): Observable<any> {
  if (result !== null && result !== undefined) return _observableThrow(result);
  else return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next('');
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = (event) => {
        observer.next((event.target as any).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}
